/**
 * External dependencies
 */
import classnames from 'classnames';

/**
 * WordPress dependencies.
 */
import { InnerBlocks, useBlockProps } from '@wordpress/block-editor';

/**
 * Inner dependencies.
 */
import Inspector from './inspector';

import { name as blockName } from '../grid-item';

const ALLOWED_BLOCKS = [ blockName ];
const Edit = ( props ) => {
	const { isSelected, attributes } = props;
	const { blockClientId } = attributes;
	const blockProps = useBlockProps( {
		className: classnames( `gutenify-section-${ blockClientId }` ),
		'data-xxx': classnames( `gutenify-section-${ blockClientId }` ),
	} );

	return <div { ...blockProps } >
		{ isSelected && <Inspector { ...props } /> }
		<InnerBlocks
			allowedBlocks={ ALLOWED_BLOCKS }
			template={ [
				[
					blockName,
				],
				[
					blockName,
				],
				[
					blockName,
				],
			] }
		/>
	</div>;
};

export default Edit;
